import { render, staticRenderFns } from "./BaseUser.vue?vue&type=template&id=89e1decc&scoped=true&"
import script from "./BaseUser.vue?vue&type=script&lang=js&"
export * from "./BaseUser.vue?vue&type=script&lang=js&"
import style0 from "./BaseUser.vue?vue&type=style&index=0&id=89e1decc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e1decc",
  null
  
)

export default component.exports